const LedgerTypeEnum = {
  Debit: 1,
  Credit: 2
};

export default LedgerTypeEnum;
